import { create } from "zustand";

interface SearchUIStore {
  mobileSearchOpen: boolean;
  setMobileSearchOpen: (open: boolean) => void;
  /**
   * Clock moved past the searched window while the page stayed open. Never set on
   * arrival — a stale URL is corrected before it renders, so there is nothing to say.
   */
  staleWindow: boolean;
  setStaleWindow: (stale: boolean) => void;
}

export const useSearchUIStore = create<SearchUIStore>((set) => ({
  mobileSearchOpen: false,
  setMobileSearchOpen: (mobileSearchOpen) => set({ mobileSearchOpen }),
  staleWindow: false,
  setStaleWindow: (staleWindow) => set({ staleWindow }),
}));
